export enum ExportType {
  Excel = 'excel',
  Csv = 'csv',
}